import Model from './Model'

export default class BookmarkUser extends Model {
  resource() {
    return 'resources/bookmark/get-users'
  }
}
